import type { AdminActivityDay, AdminStats } from '../../api/admin'

export const SESSION_STATES = [
  { key: 'closed', label: 'Finalizadas', tone: 'tag-ok' },
  { key: 'running', label: 'En curso', tone: 'tag' },
  { key: 'pending', label: 'Por recuperar', tone: 'tag-warn' },
  { key: 'aborted', label: 'Interrumpidas', tone: 'tag-err' },
  { key: 'other', label: 'Otras', tone: 'tag' },
] as const

export function activityDays(stats: AdminStats): AdminActivityDay[] {
  const end = new Date(stats.computed_at ?? Date.now())
  end.setUTCHours(0, 0, 0, 0)
  const rows = new Map((stats.session_activity_14d ?? stats.sessions_by_day_14d.map(d => ({
    ...d, closed: 0, running: 0, pending: 0, aborted: 0, other: d.sessions,
  }))).map(d => [d.day, d]))
  return Array.from({ length: 14 }, (_, i) => {
    const day = new Date(end.getTime() - (13 - i) * 86400000).toISOString().slice(0, 10)
    return rows.get(day) ?? { day, sessions: 0, closed: 0, running: 0, pending: 0, aborted: 0, other: 0 }
  })
}

export function sessionStatus(status: string) {
  return SESSION_STATES.find(s => s.key === (status === 'incomplete_pending_recovery' ? 'pending' : status))
    ?? { key: 'other', label: status || 'Sin estado', tone: 'tag' }
}

export function sessionDuration(start: string | null, end: string | null): string {
  if (!start || !end) return '—'
  const seconds = Math.floor((Date.parse(end) - Date.parse(start)) / 1000)
  if (!Number.isFinite(seconds) || seconds < 0) return '—'
  if (seconds < 60) return `${seconds} s`
  return `${Math.floor(seconds / 60)} min${seconds % 60 ? ` ${seconds % 60} s` : ''}`
}

export function dayLabel(day: string): string {
  return `${day.slice(8, 10)}/${day.slice(5, 7)}`
}
